import { Typography, Button, Space, App } from 'antd';
import { CopyOutlined, DownloadOutlined } from '@ant-design/icons';
import { JsonView, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import { Product } from '../../types/product';
import { useTheme } from '../../context/ThemeContext';

const { Text } = Typography;

interface RawDataTabProps {
  product: Product;
}

export function RawDataTab({ product }: RawDataTabProps) {
  const { isDark } = useTheme();
  const { message } = App.useApp();

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(product, null, 2));
    message.success('JSON copied to clipboard');
  };

  const handleDownload = () => {
    const blob = new Blob([JSON.stringify(product, null, 2)], {
      type: 'application/json',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${product.productid}-${product.data_source}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    message.success('JSON downloaded');
  };

  return (
    <div>
      <div
        style={{
          marginBottom: 16,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Text type="secondary">
          Raw product data from {product.data_source}
        </Text>
        <Space>
          <Button icon={<CopyOutlined />} onClick={handleCopy}>
            Copy
          </Button>
          <Button icon={<DownloadOutlined />} onClick={handleDownload}>
            Download
          </Button>
        </Space>
      </div>
      <div
        style={{
          padding: 16,
          borderRadius: 8,
          background: isDark ? '#1e1e1e' : '#f5f5f5',
          overflow: 'auto',
          maxHeight: 'calc(100vh - 400px)',
        }}
      >
        <JsonView
          data={product}
          style={isDark ? darkStyles : defaultStyles}
          shouldExpandNode={(level) => level < 2}
        />
      </div>
    </div>
  );
}
